import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.f48_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.g48_1 = LinkedHashMap().gc();
      }
      h48() {
        return this.g48_1;
      }
      h41() {
        // Inline function 'kotlin.apply' call
        this.f48_1.h41();
        return this;
      }
      i41() {
        // Inline function 'kotlin.apply' call
        this.f48_1.i41();
        return this;
      }
      c41() {
        // Inline function 'kotlin.apply' call
        this.f48_1.c41();
        return this;
      }
      d41() {
        // Inline function 'kotlin.apply' call
        this.f48_1.d41();
        return this;
      }
      e48(name) {
        // Inline function 'kotlin.apply' call
        this.f48_1.e48(name);
        return this;
      }
      o41(value) {
        // Inline function 'kotlin.apply' call
        this.f48_1.o41(value);
        return this;
      }
      y41(value) {
        // Inline function 'kotlin.apply' call
        this.f48_1.y41(value);
        return this;
      }
      t41(value) {
        // Inline function 'kotlin.apply' call
        this.f48_1.t41(value);
        return this;
      }
      q41(value) {
        // Inline function 'kotlin.apply' call
        this.f48_1.q41(value);
        return this;
      }
      w41(value) {
        // Inline function 'kotlin.apply' call
        this.f48_1.w41(value);
        return this;
      }
      u4a(value) {
        // Inline function 'kotlin.apply' call
        this.f48_1.u4a(value);
        return this;
      }
      d42(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.g48_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.f48_1.j4a();
        tmp0.c5(key, value);
        this.f48_1.h40();
        return this;
      }
      h40() {
        // Inline function 'kotlin.apply' call
        this.f48_1.h40();
        return this;
      }
      j4a() {
        return this.f48_1.j4a();
      }
      q6() {
        this.f48_1.q6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
